<main class=" md:h-full overflow-hidden relative" #mainContainer>

    <!-- TOP & BOTTOM GRADIENTS -->
    <section class="absolute top-0 z-5 flex flex-col h-full w-full justify-between pointer-events-none transition-opacity" [class]="{'opacity-0': hideGradients()}">
        <div class="bg-linear-180 from-black/30 to-transparent h-40 w-full"></div>
        <div class="bg-linear-0 from-black/30 to-transparent h-40 w-full"></div>
    </section>
    
    <!-- TOPBAR, MAP OVERLAY & FOOTER -->
    <section class="absolute z-10 py-4 px-3.5 lg:px-[18px] lg:py-[24px] w-full h-full flex flex-col justify-between pointer-events-none">
        
        <!-- TOPBAR -->
        <app-topbar/>

        <!-- MAP OVERLAY -->
        <app-overlay/>
        
        <!-- FOOTER -->
        <app-footer/>

    </section>

    <!-- CONTENT - VIEWERS -->
    <section class="w-full h-full bg-black">
        <ng-content/>
    </section>

    <!-- BOTTOM SHEET MOBILE  -->
    <div class="md:hidden overflow-hidden relative pointer-events-none">
        <app-bottom-sheet />
    </div>

    <!-- DYNAMIC CONTENT - PORTAL -->
    @if (portalContent()) {
        <section class="absolute z-20 w-full h-full top-0 left-0 pointer-events-auto">
            <ng-template [cdkPortalOutlet]="portalContent()!"/>
        </section>
    }

</main>